export const apiBaseUrl = (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '')
export const hubUrl = import.meta.env.VITE_HUB_URL || '/hubs/crm'
export const demoEnabled = import.meta.env.VITE_ENABLE_DEMO === 'true'

// Accounts is the only supported identity provider for this application.
export const centralEnabled = true
